var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.979,
    height: 25.001,
    viewBox: "0 0 24.979 25.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.979,
    height: 25.001,
    transform: "translate(0 0)",
    fill: "#d84a4a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.979,13.121c-.063.01-.065.069-.081.11a2.259,2.259,0,0,1-2.27,1.55c-.233,0-.293.05-.291.288q.015,3.592,0,7.185a2.679,2.679,0,0,1-2.076,2.671,2.958,2.958,0,0,1-.726.076q-1.882,0-3.763,0a.76.76,0,0,1-.859-.852c0-1.874-.02-3.748.009-5.621a1.3,1.3,0,0,0-1.4-1.39c-.692.024-1.385,0-2.077.005a1.234,1.234,0,0,0-1.34,1.336q0,2.811,0,5.621c0,.632-.272.9-.91.9q-1.857,0-3.715,0a2.692,2.692,0,0,1-2.8-2.8c0-2.379,0-4.757.006-7.136,0-.241-.063-.289-.294-.287A2.288,2.288,0,0,1,0,12.366a2.224,2.224,0,0,1,.551-1.378c.063-.074.132-.144.2-.213L10.794.734a2.612,2.612,0,0,1,.677-.514,2.442,2.442,0,0,1,2.634.389c.4.42.817.818,1.226,1.227q4.174,4.173,8.347,8.346a4.447,4.447,0,0,1,1.3,1.717Zm-20.83,5.1q0,1.992,0,3.983a1.231,1.231,0,0,0,1.323,1.327c.969,0,1.939-.007,2.908.006.211,0,.269-.044.267-.263-.01-1.662-.02-3.324,0-4.985a2.626,2.626,0,0,1,2.392-2.584,25.476,25.476,0,0,1,2.857-.014,1.792,1.792,0,0,1,.338.045,2.682,2.682,0,0,1,2.145,2.712q.008,2.431,0,4.863c0,.186.048.228.229.226.961-.01,1.922,0,2.884,0a1.246,1.246,0,0,0,1.385-1.387q0-4,0-7.991a.753.753,0,0,1,.829-.835c.35,0,.7,0,1.051,0a.813.813,0,0,0,.762-.581.93.93,0,0,0-.348-.994Q18.2,6.778,13.231,1.808a.875.875,0,0,0-1.446.01L2.938,10.665c-.4.4-.808.8-1.209,1.21a.837.837,0,0,0,.6,1.446h.953a.766.766,0,0,1,.867.871q0,2.016,0,4.032",
    transform: "translate(0 -0.001)",
    fill: "#d84a4a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome);
export default __webpack_public_path__ + "static/media/ic_home.fc2ca198735d6f9bb942a72f5e5d87b4.svg";
export { ForwardRef as ReactComponent };